import { defineStore } from 'pinia'
import axiosClient from "../axios";

export const useAuthStore = defineStore('auth', {
    state: () => ({
        user: {
            loggedIn: !!localStorage.getItem('LOGGEDIN'),
            isAdmin: localStorage.getItem('USERROLE') === 'Admin',
            token: localStorage.getItem('TOKEN') || null,
            data: JSON.parse(localStorage.getItem('USER')) || {},
        }
    }),

    getters: {
        loggedIn: (state) => state.user.loggedIn,
        isAdmin: (state) => state.user.isAdmin
    },

    actions: {
        setUser(user) {
            if (user) {
                this.user.data = user;
                this.user.loggedIn = true;
                this.user.isAdmin = user.ur === 'admin'

                localStorage.setItem('USER', JSON.stringify(this.user.data));
                localStorage.setItem('USERROLE', this.user.isAdmin ? 'Admin' : '')
                localStorage.setItem('LOGGEDIN', true);
            } else {
                ['USER', 'USERROLE', 'LOGGEDIN'].forEach(item => localStorage.removeItem(item))
            }
        },

        setAccessToken(token) {
            this.user.token = token;
            if (token) {
                localStorage.setItem('TOKEN', token);
            } else {
                localStorage.removeItem('TOKEN')
            }
        },

        async login(data) {
            try {
                const response = await axiosClient.post('/login', data);
                this.setUser(response.data.data.user);
                this.setAccessToken(response.data.data.tokens.access_token)
                
                return response.data.data
            } catch (error) {
                console.error(error);
                throw error;
            }
        }
    }

})




// ===
// Private helpers
// ===


